import React from 'react';
import { Card, CardContent } from './card';
import { Tooltip } from './tooltip';
import '@/design-system/typography.css';
import '@/design-system/forms.css';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  additionalInfo?: string;
  onClick?: () => void;
  backgroundColor?: string;
  tooltip?: string;
}

export function StatCard({ title, value, subtitle, additionalInfo, onClick, backgroundColor, tooltip }: StatCardProps) {
  const cardStyle: React.CSSProperties = {};
  if (backgroundColor) {
    cardStyle.backgroundColor = backgroundColor;
  }

  const cardContent = (
    <Card 
      className={`${!backgroundColor ? 'bg-white' : ''} ${onClick ? 'cursor-pointer hover:shadow-md hover:scale-[1.02] transition-all duration-200' : ''}`} 
      onClick={onClick}
      style={cardStyle}
    >
      <CardContent className="p-6">
        <h3 className="font-dashboard-text tracking-tight">{title}</h3>
        <div className="mt-2 flex items-baseline tracking-tight">
          <p className="font-heading-text">{value}</p>
          {subtitle && (
            <p className="ml-2 font-dashboard-text-muted">{subtitle}</p>
          )}
        </div>
        {additionalInfo && (
          <p className="mt-1 font-dashboard-text-muted">{additionalInfo}</p>
        )}
      </CardContent>
    </Card>
  );

  if (tooltip) {
    return (
      <Tooltip content={tooltip} position="bottom">
        {cardContent}
      </Tooltip>
    );
  }

  return cardContent;
} 